import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

export interface MisdeliveryBolCreatePayload {
  pickupNumber?: number;
  pickupBusinessName?: string;
  pickupAddress1?: string;
  pickupAddress2?: string;
  pickupCity?: string;
  pickupState?: string;
  pickupZip?: string;
  pickupPhoneNumber?: number;
  pickupContactName?: string;
  freightDescription?: string;
  isMisdeliveryHazmat?: string;
  unNumber?: string;
  totalPiecesMisdelivered?: number;
  weight?: number;
  proNumber?: number;
  misdeliveredPalletPro?: number;
  terminalId?: string;
  consigneeName?: string;
  consigneeAddress1?: string;
  consigneeAddress2?: string;
  consigneeCity?: string;
  consigneeState?: string;
  consigneeZip?: string;
  misdeliveredBolPro?: number;
}

export const CreateMisdeliveryBol = async (
  osdNumber: string | number,
  params: MisdeliveryBolCreatePayload
) => {
  try {
    const osdNumberStr = (osdNumber ?? "").toString().trim();
    const url = getUrl(ApiType.MISDELIVERY_BOL).replace(
      ":osdNumber",
      encodeURIComponent(osdNumberStr)
    );

    const { data } = await axios.post(url, params);
    return data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.misdeliveryBolCreateError, {
      badRequestOrder: "errorsFirst",
    });
  }
};
